import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-musical-rejuvenation',
  templateUrl: './musical-rejuvenation.component.html',
  styleUrls: ['./musical-rejuvenation.component.scss']
})
export class MusicalRejuvenationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
